import { Button, Heading, Stack, Text } from '@ui-lib';

export interface SwitchToWorkEmailPromptProps {
  email: string;
  /** Callback fired when user clicks the 'Switch to a work email' button */
  onSelectWorkEmail: () => void;
  /** Callback fired when user clicks the 'Continue anyway' button */
  onSelectPersonalEmail: () => void;
}

export const SwitchToWorkEmailPrompt = ({
  email,
  onSelectWorkEmail,
  onSelectPersonalEmail,
}: SwitchToWorkEmailPromptProps): JSX.Element => {
  return (
    <Stack gap="large">
      <Heading level="3">Switch to a work email?</Heading>
      <Stack gap="large">
        <Text tone="secondary" size="large">
          It looks like you are signing up with a personal email - {email}
        </Text>
        <Text tone="secondary" size="large">
          If you have a work email, signing up with it can help us find your team and tailor your Blinq
          experience based on your company needs.
        </Text>
        <Stack gap="medium">
          <Button width="full" onClick={onSelectWorkEmail}>
            Switch to a work email
          </Button>
          <Button variant="outline" width="full" onClick={onSelectPersonalEmail}>
            Continue anyway
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
